import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a entityservices - system of units
 * @param {*} state
 * @param {*} action
 */
export default function systemUnitsSearchReducer(state = initialState.systemUnitsSearch, action){

    switch(action.type)
    {
        case types.GET_SYSTEMUNITS_REQUEST:
            return {...state, item: null, error: null, isSearching: true};
        case types.GET_SYSTEMUNITS_SUCCESS:
            return {...state, item: action.data, error: null, isSearching: false};
        case types.GET_SYSTEMUNITS_ERROR:
            return {...state, error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/systemUnitsSearchReducer.js